// document.addEventListener("reintegrationFormSubmitted", afterSubmitSexes);

// function afterSubmitSexes({ detail: e }) {
//   if (e.data.success) {
//     e.form.reset();
//     e.form.classList.add("success");
//     setTimeout(() => {
//       e.form.classList.remove("success");
//       e.form.querySelector("button").disabled = false;
//     }, 15000);
//   } else {
//     alert(
//       e.data?.data?.message || "Помилка при відправці форми. Спробуйте ще раз."
//     );
//   }
// }

document.addEventListener("reintegrationFormSubmitted", afterSubmitSexes);

function afterSubmitSexes({ detail: e }) {
  if (e.data.success) {
    const form = e.form;

    // Викликаємо окрему функцію для відправки в CRM
    sendToGPlusCRM(form);

    form.reset();
    form.classList.add("success");
    setTimeout(() => {
      form.classList.remove("success");
      form.querySelector("button").disabled = false;
    }, 15000);
  } else {
    alert(
      e.data?.data?.message || "Помилка при відправці форми. Спробуйте ще раз."
    );
  }
}

async function sendToGPlusCRM(form) {
  const formData = new FormData(form);

  // Підготуємо дані для URLSearchParams
  const data = new URLSearchParams({
    action: "send_to_gplus_crm",
    name: formData.get("name") || "",
    phone: formData.get("phone") || "",
    email: formData.get("email") || "",
    note: formData.get("note") || "Запит з форми на сайті",
  });

  try {
    const response = await fetch(params.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data,
    });

    const result = await response.json();
    console.log(result);

    if (result.success) {
      console.log("Заявка успішно додана в CRM:", result.data);
    } else {
      console.warn("Помилка при відправці в CRM:", result.data);
      alert(result.data.message || "Помилка при відправці заявки в CRM");
    }
  } catch (err) {
    console.error("Помилка з’єднання з CRM:", err);
    alert("Не вдалося з’єднатися з CRM. Спробуйте пізніше.");
  }
}

((d) => {
  const images = d.querySelectorAll("#dinamic .container >  .image img");
  const titles = d.querySelectorAll("#dinamic .list .title");
  titles.forEach((title, index) => {
    title.addEventListener("click", (e) => {
      title.toggleAttribute("active");
      titles.forEach((t) => {
        if (t !== title) {
          t.removeAttribute("active");
        }
      });
      images.forEach((img, i) => {
        if (i === index && title.hasAttribute("active")) {
          img.style.setProperty("display", "block");
        } else {
          img.style.removeProperty("display");
        }
      });
    });
  });
})(document);

((d) => {
  const list = d.querySelector("#characteristics .list ul");
  if (!list) return;

  const items = [...list.querySelectorAll("li")];
  items.forEach((item, index) => {
    const counter = index < 9 ? `(0${index + 1})` : `(${index + 1})`;
    item.setAttribute("data-counter", counter);
  });
  const sides = {
    left: items.slice(Math.round(items.length / 2)),
    right: items.slice(0, Math.round(items.length / 2)),
  };
  list.innerHTML = `
		<li>
		<ul>${sides.right.map((item) => item.outerHTML).join("")}</ul>
		</li>
		<li>
		<ul>${sides.left.map((item) => item.outerHTML).join("")}</ul>
		</li>
	`;
})(document);
